import Component from "../../../lib/component";

export default class CarouselComponent extends Component {
    constructor(id_or_element, carousel = null, config = {}) {
        super({
            element: id_or_element,
            config: config
        });

        if (carousel) {
            this.carousel = carousel;
        }
    }

    get currentSlideIndex() {
        return this.carousel?.currentSlideIndex || 0;
    }

    get totalSlides() {
        return this.carousel?.slides.length || 0;
    }

    get isAutoPlaying() {
        return this.carousel?.isAutoPlaying || false;
    }
}